const mobileTop = document.querySelector('.cp-product-banner.top-content');
const mobileTopTitle = document.querySelector('.cp-product-banner.top-content .cp-banner-infos');
const productSections = document.querySelectorAll('section');
const bannerLinks = document.querySelectorAll('.cp-product-banner.desktop .cp-banner-links .cp-b-link');
const mobileBannerLinks = document.querySelectorAll('.cp-product-banner.top-content .cp-banner-links .cp-b-link');

mobileTopTitle.addEventListener('click', ()=>{
    mobileTop.classList.toggle('open');
});

// Check current Letter on viewport and highlight in alphabet filter.
const optionsProductSections = {
    /**
  * This rootMargin creates a horizontal line vertically centered
  * that will help trigger an intersection at that the very point.
  */
 rootMargin: '-50% 0% -50% 0%',

 threshold: 0
};

const observerSections = new IntersectionObserver(function(entries, observer) {
   entries.forEach( entry => {
       if(entry.isIntersecting) {
            bannerLinks.forEach(link => { 
               if(entry.target.id == link.getAttribute('href').substring(1)) {
                    bannerLinks.forEach(el => el.classList.remove('active'))
                    link.classList.add('active');
               }
           });
           mobileBannerLinks.forEach(link => { 
            if(entry.target.id == link.getAttribute('href').substring(1)) {
                mobileBannerLinks.forEach(el => el.classList.remove('active'))
                link.classList.add('active');
            }
        });
       }
   });
}, optionsProductSections);

productSections.forEach((sections, index) => {
    observerSections.observe(sections);
});